import { Injectable, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import type {
    FcAmbiguousAccountAnswer,
    FcAmbiguousAccountDialogInput,
} from '../../components/app-layout/shared/fc-ambiguous-account-dialog/fc-ambiguous-account-dialog.component';

/**
 * Asks "Which account is this?" for `FinancialConnectionsService`, which has no template of its own.
 * `app-bank-account-flow-dialogs-host` at the app root renders the dialog bound to `open` and `data`.
 */
@Injectable({ providedIn: 'root' })
export class FcAmbiguousAccountDialogStateService {
    readonly open = signal(false);
    readonly data = signal<FcAmbiguousAccountDialogInput>({ message: '' });

    private _result$: Subject<FcAmbiguousAccountAnswer | null> | null = null;

    constructor(location: Location) {
        // Browser back/forward cancels, as MatDialog's closeOnNavigation did.
        location.subscribe(() => this.answer(null));
    }

    ask(data: FcAmbiguousAccountDialogInput): Observable<FcAmbiguousAccountAnswer | null> {
        this.answer(null);
        this._result$ = new Subject<FcAmbiguousAccountAnswer | null>();
        this.data.set(data);
        this.open.set(true);

        return this._result$.asObservable();
    }

    answer(result: FcAmbiguousAccountAnswer | null): void {
        const result$ = this._result$;
        this._result$ = null;
        this.open.set(false);
        result$?.next(result);
        result$?.complete();
    }
}
